import localKey from './localKey'

const devApiUrl = 'http://www.quokka.top/yyb';//本地开发环境
const buildDevApiUrl = 'http://www.quokka.top/yyb';//打包开发环境
const buildTestApiUrl = 'http://www.quokka.top/yyb';//打包测试环境
const buildProApiUrl = '/yyb';//打包正式环境

let useApiUrl;
switch (process.env.NODE_ENV) {
    case 'development':
        useApiUrl = devApiUrl;
        break;
    case 'buildDev':
        useApiUrl = buildDevApiUrl;
        break;
    case 'buildTest':
        useApiUrl = buildTestApiUrl;
        break;
    case 'production':
        useApiUrl = buildProApiUrl;
        break;
}

export default {
    nodeDevEnv: process.env.NODE_ENV === 'development',
    apiUrl: useApiUrl,
    apiPrefix: "",
    timeout: 5000,
    requestRetry: 0,
    requestRetryDelay: 800,
    tokenKey: 'ACCESS_TOKEN',
    permissionsKey: 'PERMISSION_ARRAY',
    ...localKey
}
